var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletennis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.293 12.292c12.43-12.466 34.43-10.67 49.096 3.997a41.7 41.7 0 0 1 10.156 16.39L32.643 71.435A41.54 41.54 0 0 1 16.29 61.388C1.623 46.722-.137 24.758 12.293 12.292m3.935 33.86A11 11 0 1 0 28.45 27.86a11 11 0 0 0-12.222 18.29m57.07-6.401a.4.4 0 0 1 0 .183zm-4.325 21.12a31.06 31.06 0 0 0 4.363-20.937L39.933 73.337a29 29 0 0 0 4.4.33 30.95 30.95 0 0 0 16.537-4.766L81 92l11-11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletennis);
export default __webpack_public_path__ + "static/media/tabletennis.3b773419f6ccc041b27be6d812313c91.svg";
export { ForwardRef as ReactComponent };